<template>
  <div class="relative" @mouseover="hover = true" @mouseleave="hover = false">
    <slot name="button" />

    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-150 ease-in delay-200"
      leave-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0"
    >
      <div v-if="hover" class="absolute z-50 px-2 pt-3 transform -translate-x-1/2 left-1/2 sm:px-0">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FlyoutMenu',

  data () {
    return {
      hover: false
    }
  }
}
</script>